import ContractsList from './contractsList';
import ContractsShow from './contractsShow';

export default {
    list: ContractsList,
    show: ContractsShow,
}